export default __webpack_public_path__ + "static/media/photo6.ee69ec4e.jpg";